import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createEvent,
  deleteEventById,
  updateEventById,
  getEventById,
  getEventsByIds,
} from '../thunks/events';

const eventsAdapter = createEntityAdapter({});

export const eventsSlice = createSlice({
  name: 'events',
  initialState: eventsAdapter.getInitialState({}),
  reducers: {
    setEvents: (state, action) => {
      eventsAdapter.upsertMany(state, action.payload);
    },
    addNewEvent: (state, action) => {
      eventsAdapter.addOne(state, action.payload);
    },
    removeEvent: (state, action) => {
      eventsAdapter.removeOne(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEvent.fulfilled, (state, action) => {
        eventsAdapter.upsertOne(state, action.payload);
      })
      .addCase(deleteEventById.fulfilled, (state, action) => {
        eventsAdapter.removeOne(state, action.payload.id);
      })
      .addCase(updateEventById.fulfilled, (state, action) => {
        const { id } = action.payload;
        eventsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      })
      .addCase(getEventById.fulfilled, (state, action) => {
        eventsAdapter.upsertOne(state, action.payload); // Use adapter method for consistency
      })
      .addCase(getEventsByIds.fulfilled, (state, action) => {
        eventsAdapter.upsertMany(state, action.payload); // Use adapter method for consistency
      });
  },
});

export const { setEvents, addNewEvent, removeEvent } = eventsSlice.actions;

export const eventsAdapterSelectors = eventsAdapter.getSelectors(
  (state) => state.events
);

export default eventsSlice.reducer;
